// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"e1adfe42","292":"b2a0c4b3","453":"eae9fafd","507":"541cf590","893":"22e74600"}[chunkId] + ".chunk.js";
};